import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import flatten from "lodash/flatten";
import { UIError } from "./errors";

var Menu = /*#__PURE__*/function () {
  function Menu(config, axios) {
    _classCallCheck(this, Menu);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Menu, [{
    key: "getRecommentation",
    value: function () {
      var _getRecommentation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, channel) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.post(this.config.postfix.RECOMMENDATION_LIST_API, request, {
                  headers: {
                    "X-Source-Channel": channel
                  }
                }).then(function (response) {
                  var _response$data;

                  return (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.recommendations;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRecommentation(_x, _x2) {
        return _getRecommentation.apply(this, arguments);
      }

      return getRecommentation;
    }()
  }, {
    key: "getFrequesntlyOrderedItem",
    value: function () {
      var _getFrequesntlyOrderedItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jwtToken) {
        var headers, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                _context2.next = 5;
                return this.axios.get(this.config.postfix.FREQUENTLY_ORDERED_ITEM, {
                  headers: headers
                });

              case 5:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", null);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function getFrequesntlyOrderedItem(_x3) {
        return _getFrequesntlyOrderedItem.apply(this, arguments);
      }

      return getFrequesntlyOrderedItem;
    }()
  }, {
    key: "getMenuItemDetail",
    value: function () {
      var _getMenuItemDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(restaurantNum, productId, channel) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.get(this.config.postfix.MENU_ITEM_DETAILS.replace("{productId}", productId), {
                  params: {
                    restaurantNum: restaurantNum
                  },
                  headers: {
                    "x-source-channel": channel
                  }
                }).then(function (response) {
                  var _response$data2;

                  return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.product;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMenuItemDetail(_x4, _x5, _x6) {
        return _getMenuItemDetail.apply(this, arguments);
      }

      return getMenuItemDetail;
    }()
  }, {
    key: "processMenuAPIResponse",
    value: function () {
      var _processMenuAPIResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response, categoryId, restaurantNumber) {
        var _response$data3, menuCategoryList, subCategories;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                menuCategoryList = (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.categories;

                if (!(menuCategoryList && menuCategoryList.length > 0)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 5;
                return this.parseMenuCategory(menuCategoryList, null, null, restaurantNumber);

              case 5:
                subCategories = _context4.sent;
                return _context4.abrupt("return", {
                  subCategories: subCategories
                });

              case 9:
                return _context4.abrupt("return", {
                  subCategories: []
                });

              case 10:
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](0);
                throw new Error(_context4.t0);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 12]]);
      }));

      function processMenuAPIResponse(_x7, _x8, _x9) {
        return _processMenuAPIResponse.apply(this, arguments);
      }

      return processMenuAPIResponse;
    }()
  }, {
    key: "getMenu",
    value: function () {
      var _getMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
        var _this = this;

        var restaurantNum, categoryId, channel, params, headers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                restaurantNum = args.restaurantNum, categoryId = args.categoryId, channel = args.channel;
                params = {
                  categoryId: categoryId,
                  restaurantNum: +restaurantNum
                };
                headers = {
                  "X-Concept-Code": this.config.getConceptCode(),
                  customTimeout: 20000
                }; // TODO:: common web headers are already set in bootstrap. WEB gets passed twice

                if (channel === "APP") {
                  headers["X-Source-Channel"] = "APP";
                }

                _context5.next = 6;
                return this.axios.get(this.config.postfix.CATEGORY_MENU_ITEMS, {
                  params: params,
                  headers: headers
                }).then(function (resp) {
                  return _this.processMenuAPIResponse(resp, categoryId, restaurantNum);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 6:
                return _context5.abrupt("return", _context5.sent);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMenu(_x10) {
        return _getMenu.apply(this, arguments);
      }

      return getMenu;
    }()
  }, {
    key: "getFavorites",
    value: function () {
      var _getFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _response$data4, _response$data4$succe;

        var response, favoritesList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.get(this.config.postfix.LIST_FAVORITES_API);

              case 2:
                response = _context6.sent;
                favoritesList = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$succe = _response$data4.successResponse) === null || _response$data4$succe === void 0 ? void 0 : _response$data4$succe.favorites;

                if (!(favoritesList && favoritesList.length > 0)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", {
                  favorites: favoritesList
                });

              case 8:
                return _context6.abrupt("return", {
                  favorites: []
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFavorites() {
        return _getFavorites.apply(this, arguments);
      }

      return getFavorites;
    }()
  }, {
    key: "saveToFavorites",
    value: function () {
      var _saveToFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(productId) {
        var _response$data5;

        var response, successResponse;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.axios.post(this.config.postfix.SAVE_FAVORITES, {
                  productId: productId,
                  categoryId: "cat3920003",
                  // TODO Get the categoryId on the card clicked on.
                  togoNewFlow: true,
                  locale: "en_US"
                });

              case 2:
                response = _context7.sent;
                successResponse = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.successResponse;

                if (!successResponse) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", successResponse);

              case 8:
                return _context7.abrupt("return", null);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function saveToFavorites(_x11) {
        return _saveToFavorites.apply(this, arguments);
      }

      return saveToFavorites;
    }()
  }, {
    key: "removeFromFavorites",
    value: function () {
      var _removeFromFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(giftItemId, giftListId) {
        var _response$data6;

        var response, successResponse;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.axios.post(this.config.postfix.REMOVE_FAVORITES, {
                  giftItemId: giftItemId,
                  giftListId: giftListId,
                  locale: "en_US"
                });

              case 2:
                response = _context8.sent;
                successResponse = response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.successResponse;

                if (!successResponse) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", {
                  successResponse: successResponse
                });

              case 8:
                return _context8.abrupt("return", null);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeFromFavorites(_x12, _x13) {
        return _removeFromFavorites.apply(this, arguments);
      }

      return removeFromFavorites;
    }()
  }, {
    key: "getTarbonMenu",
    value: function () {
      var _getTarbonMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(widgetIdAndAPI) {
        var _responseData$data,
            _responseData$data$me,
            _this2 = this;

        var response, responseData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.axios.get("https://menusnow.io/API/Widget/GetMenus?".concat(widgetIdAndAPI));

              case 2:
                response = _context9.sent;
                responseData = response.data; // menus[] > Section[] > Subsection[] ?  || Item[]

                return _context9.abrupt("return", responseData === null || responseData === void 0 ? void 0 : (_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : (_responseData$data$me = _responseData$data.menus) === null || _responseData$data$me === void 0 ? void 0 : _responseData$data$me.map(function (menu) {
                  return _this2.processTurbonMenu(menu);
                }));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getTarbonMenu(_x14) {
        return _getTarbonMenu.apply(this, arguments);
      }

      return getTarbonMenu;
    }()
  }, {
    key: "processTurbonMenu",
    value: function processTurbonMenu(menu) {
      // sections -> categories
      return {
        id: menu === null || menu === void 0 ? void 0 : menu.code,
        name: "BEER",
        slug: "beer",
        imageURL: "",
        imageAltText: "",
        mobileBrowseImageURL: "",
        mobileBrowseImageAltText: "",
        legalDisclaimer: "",
        longDescription: "",
        mobileAppImageURL: "",
        menucategories: this.processTurbonMenuSection(menu.sections, "beer"),
        menu: undefined,
        isTarbonMenuCategory: true
      };
    }
    /**
     * @param preventAppendingCurrentCat used to avoid appending
     * pint-goblet-cal-270-pub-glass in breadCrumbSlug as its common for
     * most of categories. For those cateogry we need to use category name
     * of parent only.
     *
     */

  }, {
    key: "processTurbonMenuSection",
    value: function processTurbonMenuSection(sections, parentCatName) {
      var _this3 = this;

      var preventAppendingCurrentCat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return sections === null || sections === void 0 ? void 0 : sections.map(function (section) {
        var _section$items, _section$subsections;

        var currentCatSlug = preventAppendingCurrentCat ? "" : "/".concat(section === null || section === void 0 ? void 0 : section.slug);
        var parentBreadCrumbSlug = parentCatName + currentCatSlug;
        return {
          id: section.digital_display_name,
          name: section.header,
          slug: section === null || section === void 0 ? void 0 : section.slug,
          imageURL: "",
          imageAltText: "",
          mobileBrowseImageURL: "",
          mobileBrowseImageAltText: "",
          legalDisclaimer: "",
          hidePrice: undefined,
          vectorImageUrl: undefined,
          longDescription: "",
          mobileAppImageURL: "",
          isToGo: false,
          menucategories: undefined,
          menu: (section === null || section === void 0 ? void 0 : (_section$items = section.items) === null || _section$items === void 0 ? void 0 : _section$items.length) > 0 ? _this3.processTurbonMenuItems(section === null || section === void 0 ? void 0 : section.items, parentBreadCrumbSlug) : (section === null || section === void 0 ? void 0 : (_section$subsections = section.subsections) === null || _section$subsections === void 0 ? void 0 : _section$subsections.length) > 0 ? _this3.getItemsfromSubSections(section, parentBreadCrumbSlug) : undefined,
          isTarbonMenuCategory: true
        };
      });
    }
  }, {
    key: "getItemsfromSubSections",
    value: function getItemsfromSubSections(section, parentBreadCrumbSlug) {
      var _section$subsections2;

      var itemsfromSubsections = section === null || section === void 0 ? void 0 : (_section$subsections2 = section.subsections) === null || _section$subsections2 === void 0 ? void 0 : _section$subsections2.map(function (subsection) {
        return subsection === null || subsection === void 0 ? void 0 : subsection.items;
      });
      var itemsList = flatten(itemsfromSubsections);
      return this.processTurbonMenuItems(itemsList, parentBreadCrumbSlug);
    }
  }, {
    key: "processTurbonMenuItems",
    value: function processTurbonMenuItems(items, breadCrumbSlug) {
      return items === null || items === void 0 ? void 0 : items.map(function (item) {
        var _item$fields, _item$fields2, _item$fields3, _item$fields4;

        return {
          specialInfoIcons: [],
          id: item.id,
          slug: item.slug,
          imageURL: "",
          imgAltText: "",
          name: item.title,
          longDescription: item === null || item === void 0 ? void 0 : item.description,
          displayMarketPrice: false,
          price: 0,
          formattedPrice: "",
          isComplex: false,
          isDineInOnly: false,
          isAlcohol: false,
          alcoholSubClassification: "",
          greyOut: false,
          calories: null,
          nutritionalFDAMessage: "",
          mobileAppSmallImage: "",
          mobileAppLargeImage: "",
          winePairingIds: [],
          keywords: [],
          priceList: [],
          isSimpleProduct: false,
          breadCrumbSlug: breadCrumbSlug,
          fields: item !== null && item !== void 0 && item.fields ? [item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.style, "ABV ".concat(item !== null && item !== void 0 && (_item$fields2 = item.fields) !== null && _item$fields2 !== void 0 && _item$fields2.abv ? (item === null || item === void 0 ? void 0 : (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.abv) + "%" : "Varies"), item === null || item === void 0 ? void 0 : (_item$fields4 = item.fields) === null || _item$fields4 === void 0 ? void 0 : _item$fields4.origin] : undefined,
          applicableOrderTypes: null,
          dayPartInfo: []
        };
      });
    }
  }, {
    key: "getBeerMenuWidget",
    value: function () {
      var _getBeerMenuWidget = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(restaurantNumber) {
        var _response$data7;

        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.axios.get(this.config.postfix.GET_BEER_MENU_WIDGET);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.resourceBundleData[restaurantNumber]);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getBeerMenuWidget(_x15) {
        return _getBeerMenuWidget.apply(this, arguments);
      }

      return getBeerMenuWidget;
    }()
  }, {
    key: "parseMenuCategory",
    value: function () {
      var _parseMenuCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(menuCategoryList, parentCatName, parentBreadCrumbSlug, restaurantNumber) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", Promise.all(menuCategoryList.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(menuCategory) {
                    var _menuCategory$media, _menuCategory$media$l, _menuCategory$media2, _menuCategory$media2$, _menuCategory$media3, _menuCategory$media3$, _menuCategory$media4, _menuCategory$media4$, _menuCategory$media5, _menuCategory$media5$, _menuCategory$product;

                    var widgetIdAndAPI, beerListData, categoryId, imageURL, imageAltText, mobileBrowseImageURL, mobileBrowseImageAltText, longDescription, mobileAppImageURL, categoryName, legalDisclaimer, menuCategories, products, subCategory;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!(menuCategory.slug === "beer" && _this4.config.getConceptCode() === "YH" && restaurantNumber)) {
                              _context11.next = 15;
                              break;
                            }

                            _context11.prev = 1;
                            _context11.next = 4;
                            return _this4.getBeerMenuWidget(restaurantNumber);

                          case 4:
                            widgetIdAndAPI = _context11.sent;

                            if (!widgetIdAndAPI) {
                              _context11.next = 10;
                              break;
                            }

                            _context11.next = 8;
                            return _this4.getTarbonMenu(widgetIdAndAPI);

                          case 8:
                            beerListData = _context11.sent;
                            return _context11.abrupt("return", beerListData[0]);

                          case 10:
                            _context11.next = 15;
                            break;

                          case 12:
                            _context11.prev = 12;
                            _context11.t0 = _context11["catch"](1);
                            return _context11.abrupt("return", {
                              id: "",
                              name: "BEER",
                              slug: "beermenu",
                              imageURL: "",
                              imageAltText: "",
                              mobileBrowseImageURL: "",
                              mobileBrowseImageAltText: "",
                              legalDisclaimer: "",
                              longDescription: "Could not load beer menu at this moment.",
                              mobileAppImageURL: "",
                              menucategories: [],
                              isTarbonMenuCategory: true,
                              menu: []
                            });

                          case 15:
                            categoryId = menuCategory.id;
                            imageURL = (_menuCategory$media = menuCategory.media) === null || _menuCategory$media === void 0 ? void 0 : (_menuCategory$media$l = _menuCategory$media.largeImage) === null || _menuCategory$media$l === void 0 ? void 0 : _menuCategory$media$l.url;
                            imageAltText = (_menuCategory$media2 = menuCategory.media) === null || _menuCategory$media2 === void 0 ? void 0 : (_menuCategory$media2$ = _menuCategory$media2.largeImage) === null || _menuCategory$media2$ === void 0 ? void 0 : _menuCategory$media2$.imgAltText;
                            mobileBrowseImageURL = (_menuCategory$media3 = menuCategory.media) === null || _menuCategory$media3 === void 0 ? void 0 : (_menuCategory$media3$ = _menuCategory$media3.smallImage) === null || _menuCategory$media3$ === void 0 ? void 0 : _menuCategory$media3$.url;
                            mobileBrowseImageAltText = (_menuCategory$media4 = menuCategory.media) === null || _menuCategory$media4 === void 0 ? void 0 : (_menuCategory$media4$ = _menuCategory$media4.smallImage) === null || _menuCategory$media4$ === void 0 ? void 0 : _menuCategory$media4$.imgAltText;
                            longDescription = menuCategory.longDescription;
                            mobileAppImageURL = (_menuCategory$media5 = menuCategory.media) === null || _menuCategory$media5 === void 0 ? void 0 : (_menuCategory$media5$ = _menuCategory$media5.smallImage) === null || _menuCategory$media5$ === void 0 ? void 0 : _menuCategory$media5$.url;
                            categoryName = menuCategory.displayName;
                            legalDisclaimer = menuCategory.legalDisclaimer;
                            menuCategories = menuCategory.subCategories;
                            products = (_menuCategory$product = menuCategory.products) === null || _menuCategory$product === void 0 ? void 0 : _menuCategory$product.map(function (product) {
                              var _product$media, _product$media$smallI, _product$media2, _product$media2$small, _product$price, _product$price2, _product$configs, _product$configs2, _product$configs3, _product$nutrition, _product$nutrition2, _product$configs4, _product$configs5, _product$configs6;

                              var id = product.id;
                              var smallImageUrl = product === null || product === void 0 ? void 0 : (_product$media = product.media) === null || _product$media === void 0 ? void 0 : (_product$media$smallI = _product$media.smallImage) === null || _product$media$smallI === void 0 ? void 0 : _product$media$smallI.url;
                              var imgAltText = product === null || product === void 0 ? void 0 : (_product$media2 = product.media) === null || _product$media2 === void 0 ? void 0 : (_product$media2$small = _product$media2.smallImage) === null || _product$media2$small === void 0 ? void 0 : _product$media2$small.imgAltText;
                              var displayName = product === null || product === void 0 ? void 0 : product.displayName;
                              var price = product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : _product$price.value;
                              var formattedPrice = product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : _product$price2.formattedPrice;
                              var description = product === null || product === void 0 ? void 0 : product.description;
                              var lngDescription = product === null || product === void 0 ? void 0 : product.longDescription;
                              var istoGo = product === null || product === void 0 ? void 0 : (_product$configs = product.configs) === null || _product$configs === void 0 ? void 0 : _product$configs.isOnlineTogoSupported;
                              var isBeverageItem = product === null || product === void 0 ? void 0 : (_product$configs2 = product.configs) === null || _product$configs2 === void 0 ? void 0 : _product$configs2.isBeverageItem;
                              var isBulkItem = product === null || product === void 0 ? void 0 : (_product$configs3 = product.configs) === null || _product$configs3 === void 0 ? void 0 : _product$configs3.isBulkItem;
                              var cal = product === null || product === void 0 ? void 0 : (_product$nutrition = product.nutrition) === null || _product$nutrition === void 0 ? void 0 : _product$nutrition.cal;
                              var nutritionCAL = cal ? cal === null || cal === void 0 ? void 0 : cal.substring(0, cal === null || cal === void 0 ? void 0 : cal.indexOf("cal")) : null;
                              var winePairingIds = product === null || product === void 0 ? void 0 : product.winePairingIds;
                              var indicators = product === null || product === void 0 ? void 0 : product.indicators;
                              var keywords = product === null || product === void 0 ? void 0 : product.keywords;
                              var nutritionalFDAMessage = product === null || product === void 0 ? void 0 : (_product$nutrition2 = product.nutrition) === null || _product$nutrition2 === void 0 ? void 0 : _product$nutrition2.fdamessage;
                              var isAlcohol = product === null || product === void 0 ? void 0 : (_product$configs4 = product.configs) === null || _product$configs4 === void 0 ? void 0 : _product$configs4.isAlcohol;
                              var alcoholSubClassification = product.alcoholSubClassification;
                              var isSimpleProduct = product === null || product === void 0 ? void 0 : (_product$configs5 = product.configs) === null || _product$configs5 === void 0 ? void 0 : _product$configs5.isSimpleProduct;
                              var dayPartInfo = product === null || product === void 0 ? void 0 : product.dayPartInfo;
                              var advanceOrdering = product === null || product === void 0 ? void 0 : product.advanceOrdering;
                              return {
                                specialInfoIcons: indicators,
                                dayPartInfo: dayPartInfo,
                                advanceOrdering: advanceOrdering,
                                id: id,
                                imageURL: smallImageUrl,
                                imgAltText: imgAltText,
                                name: displayName,
                                breadCrumbSlug: (parentBreadCrumbSlug ? parentBreadCrumbSlug + "/" : "") + _this4.string_to_slug(categoryName),
                                slug: "".concat(product === null || product === void 0 ? void 0 : product.slug, "/").concat(id),
                                price: price,
                                formattedPrice: formattedPrice,
                                isComplex: true,
                                isDineInOnly: !istoGo,
                                isAlcohol: isAlcohol,
                                alcoholSubClassification: alcoholSubClassification,
                                isBeverageItem: isBeverageItem,
                                calories: nutritionCAL,
                                nutritionalFDAMessage: nutritionalFDAMessage,
                                winePairingIds: winePairingIds,
                                keywords: keywords,
                                isSimpleProduct: isSimpleProduct,
                                applicableOrderTypes: product === null || product === void 0 ? void 0 : (_product$configs6 = product.configs) === null || _product$configs6 === void 0 ? void 0 : _product$configs6.applicableOrderTypes,
                                isBulkItem: isBulkItem,
                                description: description,
                                longDescription: lngDescription
                              };
                            });
                            subCategory = {
                              id: categoryId,
                              name: categoryName,
                              slug: _this4.string_to_slug(categoryName),
                              imageURL: imageURL,
                              imageAltText: imageAltText,
                              mobileBrowseImageURL: mobileBrowseImageURL,
                              mobileBrowseImageAltText: mobileBrowseImageAltText,
                              legalDisclaimer: legalDisclaimer,
                              longDescription: longDescription,
                              mobileAppImageURL: mobileAppImageURL,
                              menucategories: null,
                              menu: products,
                              isTarbonMenuCategory: false
                            };

                            if (!(menuCategories && menuCategories.length > 0)) {
                              _context11.next = 31;
                              break;
                            }

                            _context11.next = 30;
                            return _this4.parseMenuCategory(menuCategories, categoryName, (parentBreadCrumbSlug ? parentBreadCrumbSlug + "/" : "") + _this4.string_to_slug(categoryName));

                          case 30:
                            subCategory.menucategories = _context11.sent;

                          case 31:
                            return _context11.abrupt("return", subCategory);

                          case 32:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, null, [[1, 12]]);
                  }));

                  return function (_x20) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function parseMenuCategory(_x16, _x17, _x18, _x19) {
        return _parseMenuCategory.apply(this, arguments);
      }

      return parseMenuCategory;
    }()
  }, {
    key: "process86edItem",
    value: function process86edItem(response) {
      var _Object$keys;

      var items = response === null || response === void 0 ? void 0 : response["86editems"];
      if (((_Object$keys = Object.keys(items)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0) return null;
      var modifirermapobject = {};
      var productMapObject = {};

      if (items !== null && items !== void 0 && items.skus) {
        var _items$skus;

        items === null || items === void 0 ? void 0 : (_items$skus = items.skus) === null || _items$skus === void 0 ? void 0 : _items$skus.forEach(function (skuid) {
          return Object.assign(modifirermapobject, _defineProperty({}, skuid, true));
        });
      }

      if (items !== null && items !== void 0 && items.products) {
        var _items$products;

        items === null || items === void 0 ? void 0 : (_items$products = items.products) === null || _items$products === void 0 ? void 0 : _items$products.forEach(function (productId) {
          return Object.assign(productMapObject, _defineProperty({}, productId, true));
        });
      }

      return {
        modifiersMap: modifirermapobject,
        productsMap: productMapObject,
        skuIds: items === null || items === void 0 ? void 0 : items.skus,
        productIds: items === null || items === void 0 ? void 0 : items.products,
        status: response === null || response === void 0 ? void 0 : response.statusMessage
      };
    }
  }, {
    key: "get86edItemIds",
    value: function () {
      var _get86edItemIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(restaurantNum) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.axios.get(this.config.postfix.ITEM_86ED, {
                  params: {
                    restaurantNum: restaurantNum
                  }
                }).then(function (response) {
                  return _this5.process86edItem(response === null || response === void 0 ? void 0 : response.data);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function get86edItemIds(_x21) {
        return _get86edItemIds.apply(this, arguments);
      }

      return get86edItemIds;
    }()
  }, {
    key: "getDayPartInfo",
    value: function () {
      var _getDayPartInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(restaurantId) {
        var _response$data8;

        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.axios.get(this.config.postfix.MENU_DAY_PART_API, {
                  params: {
                    restaurantId: restaurantId
                  }
                });

              case 2:
                response = _context14.sent;
                return _context14.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.successResponse);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getDayPartInfo(_x22) {
        return _getDayPartInfo.apply(this, arguments);
      }

      return getDayPartInfo;
    }()
  }, {
    key: "string_to_slug",
    value: function string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim

      str = str.toLowerCase(); // remove accents, swap ñ for n, etc

      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-"); // collapse dashes

      return str;
    }
  }]);

  return Menu;
}(); //CSK - Lemon Pepper Chicken - prod7020033
//CSK - Original Burger - prod7020200
//CSK - cat3850006
// CSK - Rest Id - 20800004


export { Menu as default };